module.exports = __webpack_public_path__ + "img/soccer-cover.f7a1c6d5.jpg";